import dayjs from 'dayjs'

export function formatDate(datetime, options = {}) {
  return new Intl.DateTimeFormat('fr-FR', options).format(new Date(datetime))
}

export function formatDuration(count, unit) {
  if (unit !== 'month' && count > 1) unit += 's'
  unit = unit.replace('day', 'jour').replace('week', 'semaine').replace('month', 'mois').replace('year', 'an')
  return `${count} ${unit}`
}

export function formatRelativeDate(date) {
  if (dayjs().isSame(date, 'day')) return dayjs(date).format('H:mm').split(':').join('h')
  else if (dayjs().subtract(1, 'day').isSame(date, 'day')) return 'hier à ' + dayjs(date).format('H') + 'h'
  else if (dayjs().subtract(7, 'day').isBefore(date)) return dayjs(date).format('dddd à H') + 'h'
  return dayjs(date).format('DD/MM/YYYY')
}
